import { render, staticRenderFns } from "./adding-serial.vue?vue&type=template&id=0063ec60&"
import script from "./adding-serial.vue?vue&type=script&lang=js&"
export * from "./adding-serial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports